export enum SourceKey {
    // EAP
    FASTSHIFT_PORTAL_DASHBOARD_SCREEN = "fastshiftPortalDashboardScreen",

    // M2
    FASTSHIFT_PORTAL_SELECTION_SCREEN = "fastshiftPortalSelectionScreen",
    FASTSHIFT_PORTAL_FOR_YOU_SCREEN = "fastshiftPortalForYouScreen",
    FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN = "fastshiftPortalMigrationPlanningScreen",
    FASTSHIFT_PORTAL_CUSTOMER_RESOURCES_SCREEN = "fastshiftPortalCustomerResourcesScreen",
    FASTSHIFT_PORTAL_PARTNER_RESOURCES_SCREEN = "fastshiftPortalPartnerResourcesScreen",
    FASTSHIFT_PORTAL_INELIGIBLE_NO_LICENSE_SCREEN = "fastshiftPortalIneligibleNoLicenseScreen",
    FASTSHIFT_PORTAL_INELIGIBLE_NO_ACCESS_SCREEN = "fastshiftPortalIneligibleNoAccessScreen",
    FASTSHIFT_PORTAL_GENERIC_ERROR_SCREEN = "fastshiftPortalGenericErrorScreen",
    FASTSHIFT_PORTAL_404_SCREEN = "fastshiftPortal404Screen"
}

export enum ActionKey {
    DISPLAYED = "displayed",
    CLICKED = "clicked",
    SUBMITTED = "submitted"
}

export enum ActionSubjectKey {
    // General
    BUTTON = "button",
    DROPDOWN = "dropdown",
    FLAG = "flag",
    DROPDOWN_ITEM = "dropdownItem",
    MODAL = "modal",
    SECTION = "section",
    LINK = "link",
    SEARCH = "search",
    TABLE_COLUMN_SORT = "tableColumnSort",

    // M2 - Selection Screen
    SELECTION_PAGE_DETAILS = "selectionPageDetails",

    // M2 - For You Screen & Migration Planning Screen
    MIGRATION_PLANNER_EMBED_SECTION = "migrationPlannerEmbedSection",

    // M2 - For You Screen
    FOR_YOU_PAGE_DETAILS = "forYouPageDetails"
}

export enum ActionSubjectIdKey {
    // EAP - Dashboard Screen
    REQUEST_FASTSHIFT_ASSISTANCE_CARD = "requestFastshiftAssistanceCard",
    MIGRATION_PROGRESS_TABLE = "migrationProgressTable",
    FASTSHIFT_RESOURCES_CARD_LINK_CLICK = "fastshiftResourcesCardLinkClick",
    FASTSHIFT_MIGRATION_PROGRESS_TABLE_SHOW_MORE_BUTTON_CLICK = "fastshiftMigrationProgressTableShowMoreClick",
    FASTSHIFT_MIGRATION_PROGRESS_TABLE_COLUMN_SORT = "fastshiftMigrationProgressTableColumnSort",

    // Shared
    // EAP - Dashboard Screen & M2 - For You Screen
    ORG_SELECTOR_DROPDOWN = "orgSelectorDropdown",
    MIGRATION_SUMMARY_SECTION = "migrationSummarySection",
    FASTSHIFT_MIGRATION_PROGRESS_TABLE_OPEN_SUPPORT_TICKET_CLICK = "fastshiftMigrationProgressTableOpenSupportTicketClick",
    // EAP - Dashboard Screen & M2 - Relationships Section: For You Screen & Migration Planning Screen
    REQUEST_FASTSHIFT_ASSISTANCE_MODAL = "requestFastshiftAssistanceModal",
    REQUEST_FASTSHIFT_ASSISTANCE_MODAL_SUBMIT_BUTTON_CLICK = "fastshiftAssistanceModalCommentSubmitButtonClick",
    REQUEST_FASTSHIFT_ASSISTANCE_COMMENT_CONFIRMATION_FLAG = "postCommentOutcomeConfirmationFlag",

    // M2 - Selection Screen
    SEE_DETAILS_BUTTON = "seeDetailsButton",
    DOMAIN_SELECTION_TABLE_SEARCH = "domainSelectionTableSearch",
    SELECTION_TABLE_PAGE_NAVIGATION_BUTTON = "selectionTablePageNavigationButton",
    SELECTION_TABLE_CHANGE_PAGE_SIZE_DROPDOWN_ITEM = "selectionTableChangePageSizeDropdownItem",
    SELECTION_TABLE_COLUMN_SORT = "selectionTableColumnSort",

    // M2 - For You Screen
    FASTSHIFT_MIGRATION_PROGRESS_TABLE_PAGE_NAVIGATION_BUTTON = "fastshiftMigrationProgressTablePageNavigationButton",
    FASTSHIFT_MIGRATION_PROGRESS_TABLE_CHANGE_PAGE_SIZE_DROPDOWN_ITEM = "fastshiftMigrationProgressTableChangePageSizeDropdownItem",

    // M2 - Migration Planning Screen
    EMBED_VIEW_TYPE_TOGGLE_BUTTON = "embedViewTypeToggleButton",
    SELECT_BOARD_DROPDOWN_ITEM = "selectBoardDropdownItem",
    JIRA_EMBED_LINK = "jiraEmbedLink",

    // M2 - Partner Resources Screen & Customer Resources Screen
    RESOURCE_FILTER = "resourceFilter",
    RESOURCE_LINK = "resourceLink",
    USEFUL_LINK = "usefulLink",

    // M2 - Relationships Section: For You Screen & Migration Planning Screen
    REQUEST_ASSISTANCE_BUTTON = "requestAssistanceButton",
    FASTSHIFT_RELATIONSHIPS_SECTION = "fastshiftRelationshipsSection",

    // M2 - Fastshift Ineligible Screen
    GO_BACK_BUTTON = "goBackButton",
    SIGN_IN_WITH_ANOTHER_ACCOUNT_BUTTON = "signInWithAnotherAccountButton",
    CONTACT_SUPPORT_LINK = "contactSupportLink",

    // M2 -404 Display
    GO_BACK_TO_HOME_LINK = "goBackToHomeLink",

    // M2 - Across All Screens
    SIDE_NAV_LINK = "sideNavLink",
    CUSTOMER_SELECTION_BACK_LINK = "customerSelectionBackLink",

    // Feedback Collector
    FEEDBACK_COLLECTOR_OPEN_BUTTON = "feedbackCollectorOpenButton",
    FEEDBACK_COLLECTOR_SUBMIT_BUTTON = "feedbackCollectorSubmitButton"
}

export enum SubjectAttributeKey {
    // EAP - Dashboard Screen
    SEARCH_SUPPORT = "Search Support",
    ATLASSIAN_COMMUNITY = "Atlassian Community",
    ATLASSIAN_DOCUMENTATION = "Atlassian Documentation",

    // Shared: EAP - Dashboard Screen & M2 - For You Screen
    VIEW_ASSESSMENTS = "View Assessments",
    VIEW_MIGRATIONS = "View Migrations"
}
